export function isUsingNewLayout(locale) {
  const supportedLocales = ['en', 'en_us']
  return supportedLocales.includes(locale)
}
